/* Reviews-page presentation only. Original Judge.me records remain intact.
 * Store verification confirmed by Yahya on 10 September 2026.
 */
(() => {
  const root = document.querySelector('.sa-review-page');
  if (!root || root.dataset.saReviewsReady) return;
  root.dataset.saReviewsReady = 'true';
  const list = root.querySelector('.sa-review-page__list');
  const normalize = value => value.trim().replace(/\s+/g, ' ');
  const presented = new WeakMap();
  const observer = new MutationObserver(enhance);

  function presentOpening(card) {
    let title = card.querySelector('.jdgm-review-card__details-title');
    const body = card.querySelector('.jdgm-review-card__details-description');
    if (!body) return;
    const previous = presented.get(body);
    if (previous && previous.body === body.textContent && previous.title === title?.textContent) return;
    const copy = body.textContent.trim();
    if (!copy) return;
    const firstParagraph = copy.split(/\r?\n\s*\r?\n/u)[0];
    const opening = firstParagraph.match(/^.*?[.!?](?=\s|$)/su)?.[0] || firstParagraph;
    let heading = normalize(title?.textContent || '');
    if (!heading) {
      if (!title) {
        title = document.createElement('p');
        title.className = 'jdgm-review-card__details-title';
        body.before(title);
      }
      title.textContent = opening;
    } else if (normalize(copy).startsWith(heading) && normalize(opening).length > heading.length && !/[.!?]$/u.test(heading)) {
      title.textContent = opening;
    }
    // Move an opening into the title rather than showing the same words twice.
    heading = normalize(title.textContent);
    if (normalize(opening) === heading) body.textContent = copy.slice(opening.length).trimStart();
    body.hidden = !body.textContent.trim();
    title.classList.toggle('sa-review-opening-only', body.hidden);
    presented.set(body, { body: body.textContent, title: title.textContent });
  }

  function enhance() {
    observer.disconnect();
    list.querySelectorAll('.jdgm-review-card').forEach(card => {
      presentOpening(card);
      const name = card.querySelector('.jdgm-review-card__details .jdgm-review-card__reviewer-name-wrapper');
      if (name && !name.querySelector('.sa-review-verified')) {
        const badge = document.createElement('span');
        badge.className = 'sa-review-verified';
        badge.setAttribute('role', 'img');
        badge.setAttribute('aria-label', 'Verified by Sold Attire');
        badge.title = 'Verified by Sold Attire';
        badge.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="9" fill="currentColor"/><path d="m6 10 2.5 2.5L14 7" fill="none" stroke="#fafaf7" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        name.append(badge);
        card.dataset.saVerified = 'true';
      }
    });
    observer.observe(list, { childList: true, subtree: true, characterData: true });
  }
  enhance();
})();
